<template>
  <div class="home" @touchstart="doSomething">
    <!--横屏提示 start-->
    <div id="window_mc">
      <img src="../components/images/loading-tips.jpg" alt="" />
    </div>
    <!--横屏提示 end-->

    <div class="play-wrap">
      <div :class="['v-wrap', playFlag ? 'playa' : '']" @click="playFN">
        <img src="../components/images/play.png" alt="" class="play abs" />
        <img src="../components/images/pause.png" alt="" class="pause " />
      </div>
    </div>

    <!-- loading  -->
    <Loading></Loading>

    <v-touch @swipeup="swipeup" @swipedown="swipedown">

      <!-- Page1  -->
      <Page1></Page1>

      <!-- Page2  -->
      <Page2></Page2>

      <!-- Page3  -->
      <Page3></Page3>

      <!-- Page4  -->
      <Page4></Page4>

      <!-- Page5  -->
      <Page5></Page5>

      <!-- Page6  -->
      <Page6></Page6>

      <!-- Page7  -->
      <!-- <Page7></Page7> -->

      <!-- Page8  -->
      <Page8></Page8>

      <!-- Page9  -->
      <Page9></Page9>
    </v-touch>
  </div>
</template>

<script>
import $ from "jquery";
import {serviceGetShareSignature} from "@/assets/js/uitl";
import Loading from "@/components/loading.vue";
import Page1 from "@/components/page1.vue";
import Page2 from "@/components/page2.vue";
import Page3 from "@/components/page3.vue";
import Page4 from "@/components/page4.vue";
import Page5 from "@/components/page5.vue";
import Page6 from "@/components/page6.vue";
// import Page7 from "@/components/page7.vue";
import Page8 from "@/components/page8.vue";
import Page9 from "@/components/page9.vue";
import { setTimeout, clearTimeout } from 'timers';
let timerV2 = null
export default {
  name: "Home",
  components: {
    Loading,
    Page1,
    Page2,
    Page3,
    Page4,
    Page5,
    Page6,
    // Page7,
    Page8,
    Page9
  },
  data() {
    return {
      bgMusic: null,
      clickPlay: false,
      onePlay: true,
      playFlag: true,
      screen5Hand: 0,
    };
  },
  methods: {
    playFN() {
      if (this.playFlag) {
        this.playFlag = false
        this.pauseMusic()
      } else {
        this.playFlag = true
        this.playMusic()
      }
    },
    doSomething(ev) {},
    swipeup() {
      const that = this
      let page = this.$store.state.show
      let screen = this.$store.state.screen
      console.log('up', page, screen)
      if (screen === 'screen2') {
        this.$store.dispatch("setPageFn", "page2");
        this.$store.dispatch("setScreenFn", "screen4");
        timerV2 = setTimeout(() => {
          window.playAll(window.music4)
        }, 2300)
      }
      if (screen === 'screen4') {
        this.$store.dispatch("setScreenFn", "screen5");
       
      }
      if (screen === 'screen5') {
        if (this.$store.state.showHand && this.$store.state.clickMap) {
          this.$store.dispatch("setPageFn", "page3");
          this.$store.dispatch("setScreenFn", "screen7");
          window.playAll(window.music7)
        }
      }
      if (screen === 'screen7') {
        this.$store.dispatch("setScreenFn", "screen8");
        window.playAll(window.music8)
      }
      if (screen === 'screen8') {
        this.$store.dispatch("setPageFn", "page4");
        this.$store.dispatch("setScreenFn", "screen9");
      }
      if (screen === 'screen9') {
        this.$store.dispatch("setPageFn", "page5");
        this.$store.dispatch("setScreenFn", "screen10");
        window.playAll(window.music10)
      }
      if (screen === 'screen10') {
        this.$store.dispatch("setScreenFn", "screen11");
        window.playAll(window.music11)
      }
      if (screen === 'screen11') {
        this.$store.dispatch("setPageFn", "page6");
        this.$store.dispatch("setScreenFn", "screen12");
        window.playAll(window.music12)
      }
      if (screen === 'screen12') {
        this.$store.dispatch("setScreenFn", "screen13");
        window.playAll(window.music13)
      }
      if (screen === 'screen13') {
        this.$store.dispatch("setScreenFn", "screen14");
        window.playAll(window.music14)
      }
      if (screen === 'screen14') {
        this.$store.dispatch("setPageFn", "page8");
        this.$store.dispatch("setScreenFn", "screen16");
        window.playAll(window.music15)
      }
      if (screen === 'screen16') {
        this.$store.dispatch("setScreenFn", "screen17");
        window.playAll(window.music16)
      }
      if (screen === 'screen17') {
        this.$store.dispatch("setPageFn", "page9");
        this.$store.dispatch("setScreenFn", "screen18");
      }
    },
    swipedown() {
      // return
      let page = this.$store.state.show
      let screen = this.$store.state.screen
      console.log('down', page, screen)
      if (screen === 'screen4') {
        this.$store.dispatch("setPageFn", "page1");
        this.$store.dispatch("setScreenFn", "screen2");
      }
      if (screen === 'screen5') {
        this.$store.dispatch("setScreenFn", "screen4");
        timerV2 = setTimeout(() => {
          window.playAll(window.music4)
        }, 2300)
      }
      if (screen === 'screen7') {
        this.$store.dispatch("setPageFn", "page2");
        this.$store.dispatch("setScreenFn", "screen5");
        window.playAll(window.music5)
      }
      if (screen === 'screen8') {
        this.$store.dispatch("setScreenFn", "screen7");
        window.playAll(window.music7)
      }
      if (screen === 'screen9') {
        this.$store.dispatch("setPageFn", "page3");
        this.$store.dispatch("setScreenFn", "screen8");
        window.playAll(window.music8)
      }
      if (screen === 'screen10') {
        this.$store.dispatch("setPageFn", "page4");
        this.$store.dispatch("setScreenFn", "screen9");
      }
      if (screen === 'screen11') {
        this.$store.dispatch("setScreenFn", "screen10");
        window.playAll(window.music10)
      }
      if (screen === 'screen12') {
        window.playAll(window.music11)
        this.$store.dispatch("setPageFn", "page5");
        this.$store.dispatch("setScreenFn", "screen11");
      }
      if (screen === 'screen13') {
        window.playAll(window.music12)
        this.$store.dispatch("setPageFn", "page6");
        this.$store.dispatch("setScreenFn", "screen12");
      }
      if (screen === 'screen14') {
        this.$store.dispatch("setScreenFn", "screen13");
        window.playAll(window.music13)
      }
      if (screen === 'screen15') {
        this.$store.dispatch("setScreenFn", "screen14");
      }
      if (screen === 'screen16') {
        this.$store.dispatch("setPageFn", "page6");
        this.$store.dispatch("setScreenFn", "screen14");
        window.playAll(window.music14)
      }
      if (screen === 'screen17') {
        this.$store.dispatch("setScreenFn", "screen16");
        window.playAll(window.music15)
      }
      if (screen === 'screen20' || screen === 'screen19' || screen === 'screen18') {
        this.$store.dispatch("setPageFn", "page8");
        this.$store.dispatch("setScreenFn", "screen17");
        window.playAll(window.music16)
      }
    },
    orient() {
      /**
       * 屏幕方向对应的window.orientation值：
       ipad： 90 或 -90 横屏
       ipad： 0 或180 竖屏
       Andriod：0 或180 横屏
       Andriod： 90 或 -90 竖屏
       */
      // 当竖屏时
      const windowMc = document.getElementById("window_mc");
      if (window.orientation === 180 || window.orientation === 0) {
        if (/iPhone|mac|iPod|iPad/i.test(navigator.userAgent)) {
          // console.log("当竖屏时 ios竖屏")
          windowMc.classList.remove("active");
        } else {
          // console.log("当竖屏时 android横屏")
          windowMc.classList.remove("active");
        }
      }
      // 当横屏时
      if (window.orientation === 90 || window.orientation === -90) {
        if (/iPhone|mac|iPod|iPad/i.test(navigator.userAgent)) {
          // console.log("当横屏时 ios横屏")
          windowMc.classList.add("active");
        } else {
          // console.log("当横屏时 android竖屏")
          windowMc.classList.remove("active");
        }
      }
    },
    playMusic () {
      const that = this
      if (!that.clickPlay) {
        that.clickPlay = true
        that.bgMusic.play()
      } else {
        return
      }
    },
    pauseMusic () {
      const that = this
      if (that.clickPlay) {
        that.clickPlay = false
        that.bgMusic.pause()
      } else {
        return
      }
    },
  },
  mounted() {
    const that = this;
    // 绑定事件
    window.addEventListener("orientationchange", function () {
      that.orient();
    });
    // 页面加载时调用
    that.orient();

    window.music4 = new Audio(require('../components/media/MyAudio_1.mp3'))
    window.music5 = new Audio(require('../components/media/MyAudio_2.mp3'))
    window.music7 = new Audio(require('../components/media/MyAudio_3.mp3'))
    window.music8 = new Audio(require('../components/media/MyAudio_4.mp3'))
    window.music10 = new Audio(require('../components/media/MyAudio_5.mp3'))
    window.music11 = new Audio(require('../components/media/MyAudio_6.mp3'))
    window.music12 = new Audio(require('../components/media/MyAudio_8.mp3'))
    window.music13 = new Audio(require('../components/media/MyAudio_9.mp3'))
    window.music14 = new Audio(require('../components/media/MyAudio_10.mp3'))
    window.music15 = new Audio(require('../components/media/MyAudio_11.mp3'))
    window.music16 = new Audio(require('../components/media/MyAudio_12.mp3'))
    window.music17 = new Audio(require('../components/media/MyAudio_11.mp3')) // 
    window.music19 = new Audio(require('../components/media/MyAudio_13.mp3'))
    window.music4F= true
    window.music5F= true
    window.music7F= true
    window.music8F= true
    window.music10F= true
    window.music11F= true
    window.music12F= true
    window.music13F= true
    window.music14F= true
    window.music15F= true
    window.music16F= true
    window.music17F= true
    window.music19F= true

    var oBoxy = $('body');
    that.bgMusic = new Audio(require('../components/media/MyAudio_music.mp3'))
    that.bgMusic.loop = true
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      console.log('iOS');
      if (/MicroMessenger/i.test(navigator.userAgent.toLowerCase())) {
        document.addEventListener('WeixinJSBridgeReady', function () {
          that.playMusic()
        }, false)
      } else {
        that.playMusic()
      }
    } else {
      console.log('Android');
      oBoxy.on('touchstart', function (e) {
        if (that.onePlay) {
          that.onePlay = false
          that.playMusic()
        }
      });
    }

    window.playAll = function (ele) {
      ele.currentTime = 0;
      setTimeout(() => {
        // that.bgMusic.pause()
        ele.play()
      }, 200)
    }

    window.pauseAll = function (ele) {
      ele.pause()
      // that.bgMusic.play()
      // ele.addEventListener('ended', function () {
      //   that.bgMusic.play()
      // }, false);
    }

    serviceGetShareSignature(
      $, 
      '假如徐霞客游平陆运河', 
      '妙哉！壮哉！', 
      'https://bookingmaster.gxrb.com.cn/front/2022/2022dyhh5/img/share.58d2cbd7.png',
      'https://bookingmaster.gxrb.com.cn/front/2022/2022dyhh5/index.html#/'
    )
  },
  computed: {
    stateChange() {
      return {
        show: this.$store.state.show,
        screen: this.$store.state.screen,
        showHand: this.$store.state.showHand,
        clickMap: this.$store.state.clickMap,
      };
    },
  },
  watch: {
    stateChange: function (data) {
      const { show, screen, showHand, clickMap } = data;
      const that = this

      if (screen !== "screen2") {
        window.pauseAll(window.music4)
      }
      if (screen === "screen3" || screen === "screen5") {
        clearTimeout(timerV2)
      }
      if (screen === 'screen5' && showHand && clickMap) {
      } else {
        window.pauseAll(window.music5)
      }
      if (screen !== "screen7") {
        window.pauseAll(window.music7)
      }
      if (screen !== "screen8") {
        window.pauseAll(window.music8)
      }
      if (screen !== "screen10") {
        window.pauseAll(window.music10)
      }
      if (screen !== "screen11") {
        window.pauseAll(window.music11)
      }
      if (screen !== "screen12") {
        window.pauseAll(window.music12)
      }
      if (screen !== "screen13") {
        window.pauseAll(window.music13)
      }
      if (screen !== "screen14") {
        window.pauseAll(window.music14)
      }
      if (screen !== "screen16") {
        window.pauseAll(window.music15)
      }
      if (screen !== "screen17") {
        window.pauseAll(window.music16)
      }
      if (screen !== "screen19") {
        window.pauseAll(window.music19)
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./src/assets/css/mixin";

.home {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  max-width: 750PX;
  margin: auto;
  background: #3fddec;

  .play-wrap {
    position: absolute;
    top: 30px;
    right: 30px;
    z-index: 300;

    .v-wrap {
      position: relative;
      width: 100%;
      height: 100%;

      .play {
        visibility: hidden
        }
        .pause {
          visibility: visible
        }

      &.playa {
        -webkit-animation: identifiersca 2.5s linear infinite ;
        animation: identifiersca 2.5s linear infinite ;

        .play {
          visibility: visible
        }
        .pause {
          visibility: hidden
        }
      }

      .play {
        top: 0;
        left: 0;
      }
    }

    img {
      width: 93px;
    }
  }

  /* 横竖屏样式 */
  #window_mc {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #000;
    display: none;
    -webkit-transition: all 0.6s;
    transition: all 0.6s;
  }
  #window_mc.active {
    display: block;
    z-index: 99999;
  }
  #window_mc img {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 500px;
  }
}
</style>
